import { useContext } from 'react'
import { MapContext } from './mapContext'
import GoogleMarker from '~/components/googleMap/marker'
import MapboxMarker, { CustomIconMapbox, LabelMapbox } from '~/components/mapbox/marker'
import mapboxgl, { Marker as MapboxMarkerType } from 'mapbox-gl'

interface MarkerProps {
  positions: google.maps.LatLng | google.maps.LatLngLiteral | mapboxgl.LngLatLike
  handleClick?: () => void
  onDragEnd?: (
    event: google.maps.MapMouseEvent | mapboxgl.MapMouseEvent,
    marker?: MapboxMarkerType | google.maps.Marker,
  ) => void
  customIcon?: {} | CustomIconMapbox | google.maps.Icon | google.maps.Symbol
  label?: string | google.maps.MarkerLabel | LabelMapbox
}

export default function Marker({
  positions,
  customIcon,
  handleClick,
  onDragEnd,
  label,
}: MarkerProps) {
  const mapContext = useContext(MapContext)
  if (!mapContext) {
    throw new Error('Marker must be used within a map')
  }
  const { mapProvider } = mapContext
  let layerJSXElement: JSX.Element
  if (mapProvider === 'google') {
    layerJSXElement = (
      <GoogleMarker
        position={positions as google.maps.LatLng | google.maps.LatLngLiteral}
        onClick={handleClick}
        onDragEnd={onDragEnd}
        customIcon={customIcon}
        label={label as google.maps.MarkerLabel}
      />
    )
  } else if (mapProvider === 'mapbox') {
    layerJSXElement = (
      <MapboxMarker
        position={positions as mapboxgl.LngLatLike}
        onClick={handleClick}
        customIcon={customIcon as CustomIconMapbox}
        label={label as LabelMapbox}
        onDragEnd={onDragEnd}
      />
    )
  } else {
    throw new Error(`Unsupported map provider: ${mapProvider}`)
  }

  return layerJSXElement
}
